function r() {
  const e = navigator.userAgent || navigator.vendor || window.opera, i = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(e);
  function o() {
    if ("maxTouchPoints" in navigator)
      return navigator.maxTouchPoints > 0;
    if ("msMaxTouchPoints" in navigator)
      return navigator.msMaxTouchPoints > 0;
    if (window.matchMedia) {
      const n = window.matchMedia("(pointer: coarse)");
      return n && n.matches;
    }
    return "orientation" in window;
  }
  const t = window.innerWidth <= 768;
  return i || o() || t;
}
const s = r();
export {
  s as isMobile
};
